export const divideArrayIntoChunks = (array, itemsCountInChunk) => {
    if (!array || array.length === 0) {
        return [];
    }
    const chunks = [];

    for (let i = 0; i < array.length; i += itemsCountInChunk) {
        chunks.push(array.slice(i, i + itemsCountInChunk));
    }

    return chunks;
};

/**
 * @param array
 * @param keyCallback
 * @param valueCallback - optional
 * @returns {*}
 */
export const indexArray = (array, keyCallback, valueCallback) =>
    array.reduce(
        (result, item) => ({
            ...result,
            [keyCallback(item)]: valueCallback ? valueCallback(item) : item,
        }),
        {}
    );

export const sumArray = (array, sumCallback) => array.reduce((sum, currentValue) => sum + sumCallback(currentValue), 0);
